<template>
  <v-chip
    small
    v-if="currentWorkflowStatus"
    outlined
    :color="$Color().colorFor(currentWorkflowStatusColor)"
  >
    {{ workflowStatusText }}
  </v-chip>
</template>

<script>
  export default {
    name: "WorkflowableStatus",
    props: {
      workflowable: Object,
      color: {
        type: String,
        default: "light-blue",
      },
    },
    computed: {
      workflowStatusText() {
        if (this.currentAttendancePlace) {
          return `${this.currentAttendancePlace.name} - ${this.currentWorkflowStatus.name}`;
        }

        return this.currentWorkflowStatus.name;
      },
      currentWorkflowStatus() {
        if (this.workflowable?.lastWorkflowLog?.toStatus) {
          return this.workflowable.lastWorkflowLog.toStatus;
        }

        return null;
      },
      currentAttendancePlace() {
        if (this.workflowable?.lastWorkflowLog?.attendancePlace) {
          return this.workflowable.lastWorkflowLog.attendancePlace;
        }

        return null;
      },
      currentWorkflowStatusColor() {
        if (this.currentWorkflowStatus?.color) {
          return this.currentWorkflowStatus.color;
        }

        return { color: this.color, saturation: 0 };
      },
    },
  };
</script>

<style lang="scss" scoped></style>
